// extracted by mini-css-extract-plugin
module.exports = {"Tagline":"Tagline_Tagline__3fKrt"};